import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import HighchartsChart from '../HighchartsChart';
import Options3d from '../Options3d';

var Highcharts3dChart = function (_Component) {
  _inherits(Highcharts3dChart, _Component);

  function Highcharts3dChart() {
    _classCallCheck(this, Highcharts3dChart);

    return _possibleConstructorReturn(this, (Highcharts3dChart.__proto__ || _Object$getPrototypeOf(Highcharts3dChart)).apply(this, arguments));
  }

  _createClass(Highcharts3dChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          alpha = _props.alpha,
          axisLabelPosition = _props.axisLabelPosition,
          beta = _props.beta,
          depth = _props.depth,
          fitToPlot = _props.fitToPlot,
          frame = _props.frame,
          viewDistance = _props.viewDistance,
          rest = _objectWithoutProperties(_props, ['children', 'alpha', 'axisLabelPosition', 'beta', 'depth', 'fitToPlot', 'frame', 'viewDistance']);

      var chart = {
        options3d: { enabled: true }
      };
      var zAxis = {
        id: 'zAxis'
      };

      return React.createElement(
        HighchartsChart,
        _extends({ chart: chart, zAxis: zAxis }, rest),
        React.createElement(Options3d, {
          alpha: alpha,
          axisLabelPosition: axisLabelPosition,
          beta: beta,
          depth: depth,
          fitToPlot: fitToPlot,
          frame: frame,
          viewDistance: viewDistance }),
        children
      );
    }
  }]);

  return Highcharts3dChart;
}(Component);

export default Highcharts3dChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/components/Highcharts3dChart/Highcharts3dChart.js
// module id = 807
// module chunks = 0